import React from "react";
import { render } from "react-dom";
import { App } from "./app";
import "./styles.scss";
render(React.createElement(App, null), document.getElementById("root"));
